import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconGauge",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], u = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.104 5.396a.5.5 0 0 1 0 .708l-1.75 1.75a.5.5 0 1 1-.708-.708l1.75-1.75a.5.5 0 0 1 .708 0Z",
  "clip-rule": "evenodd"
}, null, -1), _ = /* @__PURE__ */ r("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 7.3c0-2.698 2.246-4.8 5-4.8s5 2.102 5 4.8c0 .679-.168 1.343-.386 1.886a.5.5 0 1 1-.928-.372C9.869 8.357 10 7.821 10 7.3c0-2.102-1.754-3.8-4-3.8S2 5.198 2 7.3c0 .521.131 1.057.314 1.514a.5.5 0 1 1-.928.372C1.169 8.643 1 7.979 1 7.3Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  u,
  _
];
function f(a, p, i, h, g, e) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--gauge"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Gauge",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const S = /* @__PURE__ */ o(s, [["render", f]]);
export {
  S as default
};
//# sourceMappingURL=gauge.js.map
